
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-enlarger",
      function () {
        return require("private-next-pages/image-enlarger/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-enlarger"])
      });
    }
  